import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { ACCOUNT_REG_EXP } from '../../../constants';
import { errorNotification } from '../../../helpers/notification';
import { IAppParams } from '../../../hooks/useAppParams';

export interface IFormValues {
  search: string;
}

export const transactionRegExp = /^\/transactions/;
export const blockRegExp = /^\/blocks/;
export const accountsRegExp = /^\/accounts/;
export const accountEmpty = /\?account=1$/;
export const mainRegExp = /^\/$/;

const submitTransactionPage =
  (history: ReturnType<typeof useHistory>, params: IAppParams) =>
  ({ search }: IFormValues) => {
    if (search.length === 24 && ACCOUNT_REG_EXP.test(search)) {
      history.push(`/transactions/accountId/${search}`);
      return;
    }

    if (search.length === 64 || (search.length >= 19 && search.length <= 20)) {
      params.account
        ? history.push(`/transactions/accountId/${params.account}/${search}`)
        : history.push(`/transactions/${search}`);
      return;
    }

    if (search.length >= 3 && search.length <= 5) {
      history.push(`/transactions/currency/${search}`);
      return;
    }

    errorNotification('Incorrect search input');
  };

const handleBlockPage =
  (history: ReturnType<typeof useHistory>) =>
  ({ search }: IFormValues) => {
    history.push(`/blocks/${search}`);
  };

const handleAccountPage =
  (history: ReturnType<typeof useHistory>) =>
  ({ search }: IFormValues) => {
    if (ACCOUNT_REG_EXP.test(search)) {
      history.push(`/accounts/${search}`);
    } else {
      errorNotification('Incorrect account format');
    }
  };

const handleResetAccount =
  (formik: ReturnType<typeof useFormik<IFormValues>>, history: ReturnType<typeof useHistory>) =>
  () => {
    formik.setFieldValue('search', '');
    history.push('/accounts');
  };
const handleResetBlocks =
  (formik: ReturnType<typeof useFormik<IFormValues>>, history: ReturnType<typeof useHistory>) =>
  () => {
    formik.setFieldValue('search', '');
    history.push('/blocks');
  };
const handleResetTransaction = (formik: ReturnType<typeof useFormik<IFormValues>>) => () => {
  formik.setFieldValue('search', '');
};

export interface PageActions {
  regExp: RegExp;
  callback: (
    history: ReturnType<typeof useHistory>,
    params: IAppParams,
  ) => (values: IFormValues) => void;
  resetCallback: (
    formik: ReturnType<typeof useFormik<IFormValues>>,
    history: ReturnType<typeof useHistory>,
  ) => () => void;
  placeholder: string;
}

export const submitObj = [
  {
    regExp: transactionRegExp,
    callback: submitTransactionPage,
    resetCallback: handleResetTransaction,
    placeholder: 'Enter transaction Id or full hash, account Id or currency',
  },
  {
    regExp: blockRegExp,
    callback: handleBlockPage,
    resetCallback: handleResetBlocks,
    placeholder: 'Enter block ID or block height',
  },
  {
    regExp: accountsRegExp,
    callback: handleAccountPage,
    resetCallback: handleResetAccount,
    placeholder: 'Enter account Id',
  },
  {
    regExp: mainRegExp,
    callback: submitTransactionPage,
    resetCallback: handleResetTransaction,
    placeholder: 'Enter transaction Id or full hash, account Id or currency',
  },
];

export const emptyAccountPageHandlers = {
  regExp: accountEmpty,
  callback: handleAccountPage,
  resetCallback: handleResetAccount,
  placeholder: 'Enter account Id',
};

export const renderRegExp = [transactionRegExp, blockRegExp, accountsRegExp];
